export const DEFAULT_FOCUS_DURATION_MINUTES = 25;

export function getRemainingSeconds(durationSeconds, startedAt, now = Date.now()) {
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) return 0;
    if (!Number.isFinite(startedAt)) return Math.floor(durationSeconds);
    const elapsedSeconds = Math.max(0, Math.floor((now - startedAt) / 1000));
    return Math.max(0, Math.floor(durationSeconds) - elapsedSeconds);
}

export function formatFocusTime(seconds) {
    const safeSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
    const minutes = Math.floor(safeSeconds / 60);
    return `${String(minutes).padStart(2, "0")}:${String(safeSeconds % 60).padStart(2, "0")}`;
}
